import { ROBOTS_CONTENT } from 'core/common/constants';
import { type Config } from 'core/common/contexts';

export function getRobotsContentByEnvironment(config: Config): ROBOTS_CONTENT {
  return config.isProduction ? ROBOTS_CONTENT.NO_INDEX_FOLLOW : ROBOTS_CONTENT.NO_INDEX_NO_FOLLOW;
}
